export const artworkFilterGroups = [
  {
    id: 'acquisition',
    label: 'Acquisition',
    options: [
      {
        id: 'all_acquired',
        section: 'Acquired',
        label: 'All Acquired',
        predicate: artwork =>
          artwork.acquired === 'acquired' &&
          [3, 9].includes(artwork.acquisition_method),
      },
      {
        id: 'tba_commissions',
        section: 'Acquired',
        label: 'TBA21 Commissions',
        predicate: artwork =>
          artwork.acquired === 'acquired' && artwork.acquisition_method === 3,
      },
      {
        id: 'tba_academy_commissions',
        section: 'Acquired',
        label: 'TBA21 Academy Commissions',
        predicate: artwork =>
          artwork.acquired === 'acquired' && artwork.acquisition_method === 9,
      },
      {
        id: 'all_not_acquired_commissions',
        section: 'Not acquired',
        label: 'All Not Acquired',
        predicate: artwork =>
          ['commission', 'com_academy'].includes(artwork.acquired),
      },
      {
        id: 'not_acquired_tba_commissions',
        section: 'Not acquired',
        label: 'TBA21 Commissions',
        predicate: artwork => artwork.acquired !== 'commission',
      },
      {
        id: 'not_acquired_academy_commissions',
        section: 'Not acquired',
        label: 'TBA21 Academy Commissions',
        predicate: artwork => artwork.acquired !== 'com_academy',
      },
    ],
  },
  {
    id: 'text_completeness',
    label: 'Text completeness',
    options: [
      {
        id: 'no_text',
        label: 'Has no text',
        predicate: artwork =>
          !artwork.artwork_texts || artwork.artwork_texts.length === 0,
      },
      {
        id: 'no_public_text',
        label: 'Has no public text',
        predicate: artwork => {
          const texts = artwork.artwork_texts || []
          return (
            !artwork.representative_text_id ||
            !texts.some(text => text.id === artwork.representative_text_id)
          )
        },
      },
    ],
  },
]

export function filterArtworksByFacets(artworks, selections, groups = artworkFilterGroups) {
  return artworks.filter(artwork =>
    groups.every(group => {
      const selectedIds = selections[group.id] || []
      if (selectedIds.length === 0) return true

      const selectedOptions = group.options.filter(option =>
        selectedIds.includes(option.id)
      )
      return selectedOptions.some(option => option.predicate(artwork))
    })
  )
}

export function activeArtworkFilters(selections, groups = artworkFilterGroups) {
  const active = []
  groups.forEach(group => {
    group.options.forEach(option => {
      if ((selections[group.id] || []).includes(option.id)) {
        active.push({ groupId: group.id, groupLabel: group.label, ...option })
      }
    })
  })
  return active
}



// WEBPACK FOOTER //
// ./src/components/artworks/artworkFilterGroups.js